<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2BAsKw/tc-custom/9781466878433.jpg?1731883558770" alt="This image is the cover for the book Laughing on the Outside"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Laughing on the Outside
      </h1>
      <p class="bookDescription body article font2">
        <b>“A truthful look at John Candy—affectionate but unblinking.” —<i>San Francisco Examiner</i></b><br/><br/>Funny and gentle, John Candy was loved by millions of movie fans for playing true-to-life characters. Whether as the irrepressible bon vivant in <i>Splash</i>, the misunderstood slob in <i>Uncle Buck</i>, or the generous lonely salesman in <i>Planes, Trains, and Automobiles</i>, John Candy struck a perfect balance between self-deprecating humor and irresistible, emotional warmth. In this compassionate portrait of John Candy, award-winning journalist Martin Knelman reveals that behind the scenes, beneath the booming laughter, a man blessed by genius and goodness of heart was ultimately and sadly undermined by self-doubt and misguided ambition.<br/><br/>“<i>Laughing on the Outside</i> celebrates the genius of John Candy.” —<i>Vanity Fair</i><br/><br/>“Candy’s is ultimately a sad story, one that Knelman has made sympathetic and memorable, too.” —<i>Booklist</i><br/><br/>“This book is a must for Candy’s fans and an ought-to for everyone else.” —<i>Toronto Globe and Mail</i><br/><br/>“Everyone knew the happy-go-lucky comic, but Knelman shows us the sad clown underneath, which ultimately enriches the image.” —<i>Toronto Star</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin Knelman
      </h2>
      
      <p class="authorDescription body article"><P><B>Martin Knelman </B>is an award-winning cultural journalist and the author of <I>Laughing on the Outside: The Life of John Candy</I>. He lives in Toronto, Canada.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Dunne Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20a69718